import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE_API = "https://api-ims.indevconsultancy.in";

const ExpenditureSubNew = () => {
  const [kitchenId, setKitchenId] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [selectedSubKitchen, setSelectedSubKitchen] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("0");
  const [remarks, setRemarks] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [subKitchens, setSubKitchens] = useState([]);
  const [mealType, setMealType] = useState("");
  const navigate = useNavigate();


  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setSelectedDate(today);
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
    }
  }, [today]);

  useEffect(() => {
    if (!kitchenId) return;

    const fetchStock = async () => {
      try {
        const response = await axios.get(`https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${kitchenId}/`);
        const formatted = response.data.map((item) => ({
          id: item.item_id,
          itemName: `${item.stock_name} (${item.unit})`,
          availableStock: Math.abs(parseFloat(item.quantity)),
          price: parseFloat(item.price) || 0,
        }));
        setUsers(formatted);
      } catch (error) {
        console.error("Stock fetch error:", error);
      }
    };

    fetchStock();
  }, [kitchenId]);

  useEffect(() => {
    const fetchSubKitchens = async () => {
      if (!kitchenId) return;
      
      try {
        const res = await axios.get(
          `${API_BASE_API}/sub-kichange-get.php?kitchen_id=${kitchenId}`
        );
        setSubKitchens(res.data.data || []);
      } catch (err) {
        console.error("Error fetching sub kitchens:", err);
      }
    };

    fetchSubKitchens();
  }, [kitchenId]);

  // Update price when item is selected
  useEffect(() => {
    if (selectedItemId) {
      const selected = users.find((item) => item.id === parseInt(selectedItemId));
      if (selected) {
        setPrice(selected.price.toString() || "0");
      }
    } else {
      setPrice("0");
    }
  }, [selectedItemId, users]);

  const handleAddItem = () => {
    const selected = users.find((item) => item.id === parseInt(selectedItemId));
    const qty = parseFloat(quantity);
    const itemPrice = parseFloat(price);

    if (!selectedItemId) {
      alert("Please select an item.");
      return;
    }

    if (!selectedSubKitchen) {
      alert("Please select a sub kitchen.");
      return;
    }

    if (!mealType) {
      alert("Please select meal type (Breakfast / Lunch / Dinner).");
      return;
    }

    if (isNaN(qty) || qty <= 0) {
      alert("Please enter a valid quantity.");
      return;
    }

    if (isNaN(itemPrice) || itemPrice < 0) {
      alert("Please enter a valid price.");
      return;
    }

    if (qty > selected.availableStock) {
      alert("Quantity exceeds available stock.");
      return;
    }

    const alreadyAdded = selectedItems.find(
      (item) => item.kitchestock === parseInt(selectedItemId)
    );
    if (alreadyAdded) {
      alert("This item is already added.");
      return;
    }

    const totalAmount = qty * itemPrice;

    const newItem = {
      kitchestock: selected.id,
      itemName: selected.itemName,
      sub_kitchen: parseInt(selectedSubKitchen),
      expenditure_quantity: qty,
      price: itemPrice,
      amount: totalAmount,
      remarks: remarks || "",
      kitchen_id: kitchenId,
      add_date: selectedDate,
      meal_type: mealType,
      availableStock: selected.availableStock,
    };

    setSelectedItems([...selectedItems, newItem]);
    setSelectedItemId("");
    // setSelectedSubKitchen("");
    setQuantity("");
    setPrice("0");
    setRemarks("");
  };

  const handleSubmitAll = async () => {
    if (!window.confirm(`Submit ${selectedItems.length} item(s) for this sub kitchen?`)) return;
    if (selectedItems.length === 0) {
      alert("Please add at least one item.");
      return;
    }

    setIsSaving(true);
    try {
      const payload = selectedItems.map(({ itemName, availableStock, ...rest }) => rest);

      const res = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/daily-expendituresss/",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data?.status === false) {
        alert(res.data.message || "Submission failed");
        return;
      }
      
      alert("Items submitted successfully!");
      navigate("/ExpenditureListKitchen");
    } catch (err) {
      console.error("Submission error:", err);
      alert("Failed to submit. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const calculateTotalAmount = () => {
    const qty = parseFloat(quantity) || 0;
    const itemPrice = parseFloat(price) || 0;
    return (qty * itemPrice).toFixed(2);
  };

  const calculateGrandTotal = () => {
    return selectedItems.reduce((sum, item) => sum + item.amount, 0).toFixed(2);
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0 text-white">Daily Expenditure Entry</h5>
        </div>
        <div className="card-body">
          {/* Date and Item Selector */}
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">Date</label>
              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                max={today}
              />
            </div>

            <div className="col-md-8">
              <label className="form-label fw-semibold">Select Item</label>
              <select
                className="form-select"
                value={selectedItemId}
                onChange={(e) => setSelectedItemId(e.target.value)}
              >
                <option value="">Select Item</option>
                {users.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.itemName} | Available: {item.availableStock} | Price: ₹{item.price || 0}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <label className="form-label fw-semibold">Sub Kitchen</label>
            <select
              className="form-select"
              value={selectedSubKitchen}
              onChange={(e) => setSelectedSubKitchen(e.target.value)}
            >
              <option value="">Select Sub Kitchen</option>
              {subKitchens.map((data) => (
                <option key={data.subkichen_id} value={data.subkichen_id}>
                  {data.subKitchen_name}
                </option>
              ))}
            </select>
          </div>
          {/* Meal Type */}
          <div className="col-md-4 mt-3">
            <label className="form-label fw-semibold">Meal Type</label>
            <select
              className="form-select"
              value={mealType}
              onChange={(e) => setMealType(e.target.value)}
            >
              <option value="">Select Meal Type</option>
              <option value="Breakfast">Breakfast</option>
              <option value="Lunch">Lunch</option>
              <option value="Dinner">Dinner</option>
            </select>
          </div>

          {/* Quantity, Price & Total */}
          {selectedItemId && (
            <div className="row mt-3 g-3">
              {/* <div className="col-lg-4">
                <label className="form-label fw-semibold">Sub Kitchen</label>
                <select
                  className="form-select"
                  value={selectedSubKitchen}
                  onChange={(e) => setSelectedSubKitchen(e.target.value)}
                >
                  <option value="">Select Sub Kitchen</option>
                  {subKitchens.map((data) => (
                    <option key={data.subkichen_id} value={data.subkichen_id}>
                      {data.subKitchen_name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="col-md-4">
                <label className="form-label fw-semibold">Quantity</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder="Enter quantity"
                  value={quantity}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Price (₹)</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control"
                  placeholder="Enter price"
                  value={price}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setPrice(e.target.value)}
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">Total Amount (₹)</label>
                <input
                  type="text"
                  className="form-control"
                  value={calculateTotalAmount()}
                  readOnly
                  style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter remarks (optional)"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
            </div>
          )}

          {/* Add Button */}
          <div className="text-end mt-3">
            <button 
              className="btn btn-info" 
              onClick={handleAddItem}
              disabled={!selectedItemId || !selectedSubKitchen || !quantity || !mealType}
            >
              Add Item to List
            </button>
          </div>

          {/* Display Table */}
          {selectedItems.length > 0 && (
            <>
              <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Meal</th>
                      <th>Available</th>
                      <th>Used</th>
                      <th>Price (₹)</th>
                      <th>Total Amount (₹)</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItems.map((item, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{item.itemName}</td>
                        <td>{item.meal_type || "-"}</td>
                        <td>
                          <span className="badge bg-secondary">
                            {item.availableStock}
                          </span>
                        </td>
                        <td>{item.expenditure_quantity}</td>
                        <td>₹{item.price.toFixed(2)}</td>
                        <td className="fw-bold">₹{item.amount.toFixed(2)}</td>
                        <td>{item.remarks || "-"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                              const newItems = [...selectedItems];
                              newItems.splice(i, 1);
                              setSelectedItems(newItems);
                            }}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="table-dark">
                    <tr>
                      <td colSpan="6" className="text-end fw-bold">
                        Grand Total:
                      </td>
                      <td className="fw-bold">
                        ₹{calculateGrandTotal()}
                      </td>
                      <td colSpan="2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>Total Items:</strong> {selectedItems.length}
                </div>
                <div>
                  <button
                    className="btn btn-success mt-3"
                    onClick={handleSubmitAll}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit All"
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenditureSubNew;